import { t } from "i18next";

import { MfValidator } from "./MfValidator";

export const createMfRequired = (): MfValidator => ({
  isRequired: true,
  test: (node) => {
    const { value } = node;
    const isEmpty = Array.isArray(value) ? value.length === 0 : !value;
    if (isEmpty) {
      return Promise.reject(Error(t("Field required")));
    }
    return Promise.resolve();
  },
});
